import {
  TransactionVolumeBadge,
  TransactionVolumeBadgeType,
} from "@/components/shared/transaction-volume-badge";

export interface ActivityTabSelection {
  content: string | React.ReactNode;
  type: ActivityTabTypes;
}

export enum ActivityTabWhaleValuesType {
  Whale = 10000,
  Dolphin = 1000,
  Fish = 100,
  Shrimp = 1,
}

export enum ActivityTabWhaleLabelsType {
  Whale = "10k",
  Dolphin = "1k",
  Fish = "100",
  Shrimp = "1",
}

export enum ActivityTabTypes {
  All = "all",
  Whale = TransactionVolumeBadgeType.Whale,
  Dolphin = TransactionVolumeBadgeType.Dolphin,
  Fish = TransactionVolumeBadgeType.Fish,
  Shrimp = TransactionVolumeBadgeType.Shrimp,
}

export const activityTabs: Array<ActivityTabSelection> = [
  {
    content: "All",
    type: ActivityTabTypes.All,
  },
  {
    content: (
      <TransactionVolumeBadge
        type={ActivityTabTypes.Whale}
        text={`>$${ActivityTabWhaleLabelsType.Whale}`}
        width={28}
      />
    ),
    type: ActivityTabTypes.Whale,
  },
  {
    content: (
      <TransactionVolumeBadge
        type={ActivityTabTypes.Dolphin}
        text={`>$${ActivityTabWhaleLabelsType.Dolphin} to $${ActivityTabWhaleLabelsType.Whale}`}
      />
    ),
    type: ActivityTabTypes.Dolphin,
  },
  {
    content: (
      <TransactionVolumeBadge
        type={ActivityTabTypes.Fish}
        text={`>$${ActivityTabWhaleLabelsType.Fish} to $${ActivityTabWhaleLabelsType.Dolphin}`}
      />
    ),
    type: ActivityTabTypes.Fish,
  },
  {
    content: (
      <TransactionVolumeBadge
        type={ActivityTabTypes.Shrimp}
        text={`$${ActivityTabWhaleLabelsType.Shrimp} to $${ActivityTabWhaleLabelsType.Fish}`}
      />
    ),
    type: ActivityTabTypes.Shrimp,
  },
];

export const COLUMNS_WIDTH = [6, 7, 18, 12, 14, 12, 11, 16, 4];

export enum ActivityFilterFields {
  tokenPublicKey = "tokenPublicKey",
  traderPublicKey = "traderPublicKey",
  traderAssetsUsd = "traderAssetsUsd",
  tradeValueUsd = "tradeValueUsd",
  tradeTimestamp = "tradeTimestamp",
}
